import Head from "next/head";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}

export const SEO = ({
  title = "Indian Food Caterers | Catering Services for All Events",
  description = "Tabla offers top catering services across the USA! Enjoy authentic Indian food catering for breakfast, lunch, brunch, corporate events, parties, and halal catering.",
  keywords = "catering services, breakfast catering, indian food caterers, indian caterers, lunch catering, brunch catering, corporate lunch catering, party catering, boxed lunch catering, chinese food catering, halal catering",
  image = "https://www.tablacatering.com/shared/cateringNationwideLogo.jpg",
  url = "https://www.tablacatering.com/",
}: SEOProps) => {
  return (
    <Head>
      {/* Primary Meta Tags */}
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" content={description} />
      <meta name="author" content="Tabla Cuisine" />
      <meta name="keywords" content={keywords} />
      <title>{title}</title>
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Head>
  );
};
